import { render, staticRenderFns } from "./TrainerInput.vue?vue&type=template&id=17996d0f&"
import script from "./TrainerInput.vue?vue&type=script&lang=js&"
export * from "./TrainerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerInput.vue"
export default component.exports